import type { ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { useAppContext } from '@/Main';

type CardChartCircleLoadingProps = {
  title?: ReactNode;
  tooltip?: string;
  width?: number;
  height?: number;
};

const CardChartCircleLoading = ({
  title,
  tooltip,
  width = 180,
  height = 180
}: CardChartCircleLoadingProps) => {
  const {
    config: { theme }
  } = useAppContext() as { config: { theme: string } };

  return (
    <Card>
      <FalconCardHeader
        title={
          <div>
            {title}
            {tooltip ? <HelpTooltip html={tooltip} /> : null}
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
      />
      <Card.Body className="px-0">
        <div className="chart_loading_wrapper">
          <div>
            <div className="circle_chart_loading"></div>
          </div>
          <div className="legend_chart_loading"></div>
        </div>
        <div className="text-center"></div>
      </Card.Body>
      <Card.Footer className="bg-body-tertiary fs--2">
        <div className="text_chart_loading"></div>
      </Card.Footer>
      <style>
        {`
            .legend_chart_loading,.circle_chart_loading,text_chart_loading{
              background:${changeBgColor(theme)};
              background-size: 200% 100%;
              background-position: 100% 0;
            }
            .circle_chart_loading{
                width :${width}px;
                height :${height}px;
            }
        `}
      </style>
    </Card>
  );
};

export default CardChartCircleLoading;
